import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_comp",
  "use": "icon-icon_comp-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icon_comp\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#EBB954\" fill-rule=\"nonzero\" cx=\"8\" cy=\"8\" r=\"8\" /><text font-family=\"PingFangSC-Medium, PingFang SC\" font-size=\"10\" font-weight=\"400\" fill=\"#F8F9FA\">\n                        <tspan x=\"2.28\" y=\"12.98\">企</tspan>\n                    </text></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol